import script from "./SelectSaleChannel.vue?vue&type=script&setup=true&name=SelectSaleChannel&lang=js"
export * from "./SelectSaleChannel.vue?vue&type=script&setup=true&name=SelectSaleChannel&lang=js"

import "./SelectSaleChannel.vue?vue&type=style&index=0&id=55339b92&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55339b92"]])

export default __exports__